import get from 'lodash/get'
import React from 'react'
import { InlineDisplayContent } from '@ztechapps/webui.input'
import { DeliveryConfirmationSelect } from './DeliveryConfirmationSelect'
import { OrderDeliveryConfirmation } from '@ztechapps/order.common'
import { OrderDeliveryConfirmationEnum } from '@ztechapps/common.contract'
import { useCheckoutContext } from '../../index'

export const DeliveryConfirmation = () => {
  const context = useCheckoutContext()
  const [shippingOptions, setShippingOptions] = context.shippingOptions
  const [showLoadingOverlay] = context.showLoadingOverlay
  const description = get(OrderDeliveryConfirmation, `${shippingOptions?.deliveryConfirmation}.description`)
  const value = shippingOptions?.deliveryConfirmation ?? OrderDeliveryConfirmationEnum.none

  return (
    <InlineDisplayContent label="Delivery Confirmation" help={description}>
      <DeliveryConfirmationSelect
        isDisabled={showLoadingOverlay}
        value={{ value, label: value }}
        onChange={(e: any) => {
          setShippingOptions({ deliveryConfirmation: e.value })
        }}
      />
    </InlineDisplayContent>
  )
}
